module.exports = __webpack_public_path__ + "static/media/np.b77457a9.svg";